import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-[#fffbf0] pt-8 pb-10 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-52">
      <div className="max-w-4xl mx-auto text-center" data-id="element-53">
        {/* Pre-headline */}
        <p className="text-[#e63946] font-bold tracking-wider uppercase mb-3 text-sm sm:text-base" data-id="element-54">
          Para mamás en Perú que quieren dejar de sufrir a fin de mes
        </p>

        {/* Main Headline */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-[#1e3a5f] leading-tight mb-2 tracking-tight whitespace-nowrap" data-id="element-55">
          "NO ME ALCANZA"
        </h1>

        {/* Subheadline */}
        <h2 className="text-lg sm:text-xl md:text-2xl font-medium text-slate-700 mb-6" data-id="element-56">
          Presupuesto Anti-Fin-de-Mes <br className="hidden sm:block" data-id="element-57" />
          <span className="text-[#1e3a5f] font-bold" data-id="element-58">
            Método Doble Control 4×4: sobres + topes digitales (Yape/Plin)
          </span>
        </h2>

        {/* Lead Text */}
        <div className="max-w-2xl mx-auto text-left bg-white p-5 rounded-2xl shadow-sm border border-stone-100 mb-8" data-id="element-59">
          <p className="text-base text-slate-700 mb-3" data-id="element-60">Te pasa así:</p>
          <p className="text-base text-slate-700 mb-1" data-id="element-61">
            La primera semana "más o menos".
          </p>
          <p className="text-base text-slate-700 mb-1" data-id="element-62">
            La segunda ya estás midiendo.
          </p>
          <p className="text-base text-slate-700 mb-4 font-medium" data-id="element-63">
            Y la tercera… empiezas a inventar.
          </p>

          <p className="text-base text-slate-700 mb-3" data-id="element-64">
            Y lo peor no es la plata. Es esa sensación de estar fallando, aunque
            estés haciendo todo.
          </p>

          <p className="text-lg font-bold text-[#1e3a5f]" data-id="element-65">
            No te falta disciplina. Te falta un sistema que aguante la vida
            real.
          </p>
        </div>

        {/* Product Image */}
        <div className="relative mx-auto mb-8 max-w-sm transform hover:scale-105 transition-transform duration-500" data-id="element-66">
          <div className="absolute inset-0 bg-[#1e3a5f] rounded-3xl rotate-3 opacity-10 blur-xl" data-id="element-67"></div>
          <img src="https://cdn.magicpatterns.com/uploads/1VGYKJdsxZuzi2FK9oYQdV/Mockup_1.png" alt="Guía No Me Alcanza en tablet" className="relative rounded-2xl shadow-2xl w-full border-4 border-white" data-id="element-68" />
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center" data-id="element-69">
          <CTAButton className="w-full sm:w-auto text-lg sm:text-xl px-8 py-4" onClick={scrollToOffer} data-id="element-70">
            Quiero el método 4×4
          </CTAButton>
        </div>
      </div>
    </section>;
}